import ReCAPTCHA from 'react-google-recaptcha';

type RecaptchaV2Props = {
  onChange: (token: string | null) => void;
};

export default function RecaptchaV2({ onChange }: RecaptchaV2Props) {
  return (
    <ReCAPTCHA
      sitekey={window.env.reCaptchaKeyV2}
      onChange={onChange}
      size='normal'
      data-testid='recaptcha-v2-box'
    />
  );
}
